import { render, staticRenderFns } from "./EditBorn.vue?vue&type=template&id=76591562&"
import script from "./EditBorn.vue?vue&type=script&lang=js&"
export * from "./EditBorn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports